export default __webpack_public_path__ + "static/media/Brotherside-Signature.2af80c35.ttf";